<script lang="ts" setup>
withDefaults(
  defineProps<{
    title: string;
    hint: string;
    selected: boolean;
    testId: string;
    disabled?: boolean;
  }>(),
  { disabled: false },
);

const emit = defineEmits<{ (e: 'select'): void }>();
</script>

<template>
  <button
    type="button"
    :data-test="testId"
    class="option-card"
    :class="{ 'option-card--selected': selected }"
    :aria-pressed="selected"
    :disabled="disabled"
    @click="emit('select')"
  >
    <span class="option-card__title">{{ title }}</span>
    <span class="option-card__hint">{{ hint }}</span>
  </button>
</template>

<style lang="postcss" scoped>
.option-card {
  @apply flex min-w-[220px] flex-1 flex-col items-start gap-1 rounded-xl border border-tint-80;
  @apply bg-white p-4 text-left transition-colors;
}

.option-card:hover:not(:disabled):not(.option-card--selected) {
  @apply border-shade-840;
}

.option-card--selected {
  @apply border-highlight-500 bg-copilot-soft-gradient;
}

.option-card:disabled {
  @apply cursor-not-allowed;
}

.option-card__title {
  @apply font-sans text-sm font-bold leading-6 text-shade-820;
}

.option-card--selected .option-card__title {
  @apply font-extrabold text-shade-900;
}

.option-card__hint {
  @apply font-sans text-sm font-normal leading-[21px] text-shade-800;
}

.option-card--selected .option-card__hint {
  @apply text-shade-900;
}
</style>
